<template>
  <div id="surveySummary">
    <h5 class="mt-4 mb-3">{{ $t("SURVEY_SUMMARY") }}</h5>

    <b-card-group class="pt-2 pb-4">
      <b-card>
        <ul class="list-inline mb-0 text-center">
          <li class="list-inline-item">
            <strong class="mr-2">ポイント</strong>
          </li>
          <li class="list-inline-item">
            {{totalPoint}}<small>/1000</small>
          </li>
        </ul>
      </b-card>
      <b-card>
        <ul class="list-inline mb-0 text-center">
          <li class="list-inline-item">
            <strong class="mr-2">脳機能ステータス</strong>
          </li>
          <li class="list-inline-item">
            {{brainFunctionStatus}}
          </li>
        </ul>
      </b-card>
    </b-card-group>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr class="d-flex">
            <th class="col-3">{{ $t("CATEGORY") }}</th>
            <th class="col-2">{{ $t("SURVEY_DATE") }}</th>
            <th class="col-2">{{ $t("GRADE") }}</th>
            <th class="col-5">{{ $t("MESSAGE") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="surveySummaryRow d-flex"
            v-for="(category, index) in surveySummary"
            v-bind:key="index"
            v-on:click="scrollToAnswerAndQuetion(category.category_id)"
          >
            <td class="col-3">{{ category.category_name }}</td>
            <td
              class="col-2"
              v-bind:style="{
                color: getSurveyDateColor(category.created_at),
              }"
            >
              {{ convertSurveyDate(category.created_at) }}
            </td>
            <td
              class="col-2"
              v-bind:style="{ color: getGradeColor(category.grade) }"
            >
              {{ convertGrade(category.grade) }}
            </td>
            <td class="col-5" v-html="convertMessage(category.message)"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-for="(category, index) in surveySummary" v-bind:key="index">
      <h5
        :id="'answerAndQuetion' + category.category_id"
        class="mt-4 mb-3 h3 strong"
      >
        {{ category.category_name }}
      </h5>
      <survey class="mb-3"
        :survey="
          createAnswerAndQuetionModel(
            category.category_id,
            category.answer,
            category.question
          )
        "
      ></survey>
      <a href="javascript:void(0);" v-on:click="scrollTo(0)">{{
        $t("GO_PAGE_TOP")
      }}</a>
      <hr class="breakLine mb-5" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as SurveyVue from "survey-vue";
import { GET_SERVEY_SUMMARY } from "@/store/actions.type";
export default {
  name: "surveySummary",
  data() {
    return {
      totalPoint: null,
      brainFunctionStatus: null,
      surveySummary: [],
    };
  },
  async created() {
    this.params = this.$route.params;
    let surveySummary = await this.getSurveySummary();
    this.totalPoint = surveySummary.total_point;
    this.brainFunctionStatus = surveySummary.brain_function_status;
    this.surveySummary = surveySummary.data;
  },
  methods: {
    /**
     * 全ての問診結果を取得します。
     * @return {array} 取得された問診回答のサマリーを返します。
     */
    getSurveySummary: async function() {
      const surveySummary = await this.$store.dispatch(GET_SERVEY_SUMMARY, {
        user_id: this.params.patientId,
      });

      return surveySummary;
    },
    /**
     * 指定された問診カテゴリーの質問と回答からSurveyのモデルを作成します。
     * @param {answer} 問診カテゴリーの回答を指定します。
     * @param {question}問診カテゴリーの質問を指定します。
     * @return {SurveyVue} 作成されたモデルを返します。
     */
    createAnswerAndQuetionModel: function(categoryId, answer, question) {
      let questionPages = JSON.parse(question);
      let elements = [];
      for (const page of questionPages.pages) {
        elements = elements.concat(page.elements);
      }
      questionPages["pages"] = [{ name: "page1", elements: elements }];

      const parsedAnswer = JSON.parse(answer);

      if (categoryId == 102 // 102は睡眠
        && parsedAnswer
        && parsedAnswer.question5 != null // 回答の中身がFitbitではなく問診回答である
      ) {
        this.overwriteSleepingHours(questionPages, parsedAnswer);
      }

      const model = new SurveyVue.Model(questionPages);
      model.data = parsedAnswer;
      model.mode = "display";

      return model;
    },
    /**
     * 実施日を表示用に変換します。
     * @param {surveyDate} 変換対象の実施日を指定します。
     * @return {string} 変換された実施日を返します。
     */
    convertSurveyDate: function(surveyDate) {
      let result = this.$t("NO_SURVEY_ANSWER");
      if (surveyDate !== null) {
        result = moment(surveyDate).format("YYYY-MM-DD");
      }

      return result;
    },
    /**
     * グレードを表示用に変換します。
     * @param {grade} 変換対象のグレードを指定します。
     * @return {string} 変換されたグレードを返します。
     */
    convertGrade: function(grade) {
      let result = "-";
      if (grade !== null) {
        result = grade;
      }

      return result;
    },
    /**
     * メッセージを表示用に変換します。
     * @param {message} 変換対象のメッセージを指定します。
     * @return {string} 変換されたメッセージを返します。
     */
    convertMessage: function(message) {
      let result = "-";
      if (message !== null) {
        result = message;
      }

      return result;
    },
    /**
     * 指定された実施日に対応する文字色を取得します。
     * @param {surveyDate} 実施日を指定します。
     * @return {string} 条件に一致した文字色を返します。
     */
    getSurveyDateColor: function(surveyDate) {
      let color = "black";
      if (surveyDate === null) {
        color = "gray";
      }

      return color;
    },
    /**
     * 指定されたグレードに対応する文字色を取得します。
     * @param {grade} グレードを指定します。
     * @return {string} 条件に一致した文字色を返します。
     */
    getGradeColor: function(grade) {
      let color = "";
      switch (grade) {
        case 1:
          color = "red";
          break;
        case 2:
          color = "#edb918"; // 濃い黄色
          break;
        default:
          color = "black";
          break;
      }

      return color;
    },
    /**
     * 指定されたカテゴリの質問と回答までスクロールします。
     * @param {categoryId} カテゴリIDを指定します。
     */
    scrollToAnswerAndQuetion: function(categoryId) {
      const elementId = "answerAndQuetion" + categoryId;
      const targetElement = document.getElementById(elementId);
      const clientRect = targetElement.getBoundingClientRect();
      const y = window.pageYOffset + clientRect.top;
      this.scrollTo(y);
    },
    /**
     * 指定された箇所までスクロールします。
     * @param {y} 画面のスクロール位置(y座標)を指定します。
     */
    scrollTo: function(y) {
      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    },

    // 睡眠問診内のexpression式(他の回答を元に算出される問い)に不具合があるため、正しい計算後の値で上書きする
    overwriteSleepingHours: function (questionPages, parsedAnswer) {
      const answersForWeekday = {
        bedtime: {hour: parsedAnswer.question5, min: parsedAnswer.question6},
        wakeUpTime: {hour: parsedAnswer.question7, min: parsedAnswer.question8},
        napTime: {hour: parsedAnswer.question10, min: parsedAnswer.question11}
      };
      const answersForWeekend = {
        bedtime: {hour: parsedAnswer.question13, min: parsedAnswer.question14},
        wakeUpTime: {hour: parsedAnswer.question15, min: parsedAnswer.question16},
        napTime: {hour: parsedAnswer.question18, min: parsedAnswer.question19}
      };

      function calcSleepHours(answers) {
        let bedtimeNumber = answers.bedtime.hour + (answers.bedtime.min / 60);
        let wakeUpTimeNumber = answers.wakeUpTime.hour + (answers.wakeUpTime.min / 60);

        let nightSleepingHours = 0;
        if (wakeUpTimeNumber >= bedtimeNumber) {
          nightSleepingHours = wakeUpTimeNumber - bedtimeNumber;
        } else {
          nightSleepingHours = (24 - bedtimeNumber) + wakeUpTimeNumber;
        }
        let napSleepingHours = answers.napTime.hour + (answers.napTime.min / 60);

        return nightSleepingHours + napSleepingHours;
      }

      // 時間の表示フォーマットとして正しくはないが、アプリ側の表示フォーマット（HH.mm）と合わせている
      function formatSleepHours(hours) {
        let hoursBeforeDecimalPoint = Math.floor(hours);
        let hoursAfterDecimalPoint = hours - hoursBeforeDecimalPoint;

        let minutes = hoursAfterDecimalPoint * 60;

        return `${hoursBeforeDecimalPoint}.${minutes}`;
      }

      questionPages.pages[0].elements[4]['expression'] = formatSleepHours(calcSleepHours(answersForWeekday));
      questionPages.pages[0].elements[15]['expression'] = formatSleepHours(calcSleepHours(answersForWeekend));
    }
  },
};
</script>

<style lang="scss">
.surveySummaryRow:hover {
  background-color: rgba(#000, .075);
  cursor: pointer;
}
.breakLine {
  border: 0;
  border-top: 1px solid black;
}

.sv_p_root {
  .sv_q_radiogroup.undefined.checked {
    .sv_q_radiogroup_label {
      background-color: lightskyblue;
    }
  }
  .sv_q_checkbox.sv-q-col-1.undefined.checked {
    .sv_q_checkbox_label {
      background-color: lightskyblue;
    }
  }

  fieldset.sv_qcbc {
    margin-left: 30px !important;
  }

  .sv_q_required_text {
    display: none;
  }

  .hideOnPortal {
    display: none;
  }

  h5 {
    margin-top: 20px;
  }

  .sv_q_text_root {
    margin-left: 30px;
    margin-bottom: 25px;
  }
}
</style>
